<div class="oauth-splash">
  <div class="oauth-splash__card">
    <img [src]="logoPath" [alt]="logoAlt" class="oauth-splash__logo" />
    <p class="oauth-splash__text">Carregando plataforma…</p>
    <div class="oauth-splash__spinner" aria-hidden="true"></div>
  </div>
</div>
